// 精彩瞬间列表
const wonderfulList = r => require.ensure(
  [],
  () => r(require('@/components/wonderful-moment/index')),
  'wonderfulMoment'
)

// 照片墙
const photoList = r => require.ensure(
  [],
  () => r(require('@/components/wonderful-moment/photo-list')),
  'wonderfulMoment'
)

export default [
  // 精彩瞬间列表
  {
    path: '/wonderfulList/index',
    name: 'wonderfulList',
    component: wonderfulList,
    meta: {
      title: '精彩图集'
    }
  },
  // 照片墙
  {
    path: '/wonderfulList/photoList',
    name: 'photoList',
    component: photoList,
    meta: {
      title: '精彩图集'
    }
  }

]



// WEBPACK FOOTER //
// ./src/router/sub-route/wonderful-moment.js